import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getWorkflow } from "actions/workflows";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import NodeGraph2 from "components/Workflows/NodeGraph2";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  .selectedView {
    font-weight: bold;
  }

  .view {
    cursor: pointer;
  }

  .view:hover {
    text-decoration: underline;
  }
`;

const WorkflowGraph2 = () => {
  const { workflow_id } = useParams();
  const navigate = useNavigate();

  console.log("!!! WORKFLOW ID: ", workflow_id);
  const { workflow } = useSelector((state) => state.workflows);
  const dispatch = useDispatch();

  useEffect(() => {
    if (workflow_id) {
      dispatch(getWorkflow(workflow_id));
    }

    window.document.body.classList.add("overflow-hidden");

    return () => {
      window.document.body.classList.remove("overflow-hidden");
    };

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    //dispatch(clearWorkflow());
    if (workflow) {
      window.history.replaceState(
        null,
        "Edit Workflow",
        `/workflow/${workflow.public_id}/graph2`
      );
    } else if (!workflow_id) {
      window.history.replaceState(null, "New Workflow", "/workflow");
    }

    // eslint-disable-next-line
  }, [workflow]);

  if (!workflow) {
    return (
      <>
        <GlobalStyle />
        <Sidebar {...sidebar} />
        <div
          className="relative md:ml-64 bg-blueGray-100 pt-24"
          style={{ height: "100%", minHeight: "100vh", zIndex: 30 }}
        >
          <div style={{ marginLeft: "50px" }}>Loading Graph...</div>
        </div>
      </>
    );
  }

  return (
    <>
      <GlobalStyle />
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh", zIndex: 30 }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          <NodeGraph2
            workflow={workflow}
            onClose={() => {
              navigate(`/workflow/${workflow.public_id}`);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default WorkflowGraph2;
